import { type MarketplaceBuyAsset, type WagmiCallbacks } from '@pkg/types';

import { CollectionChainType } from '@app/client';
import { useBuyStore } from '@app/store/zustand';

import { PREPARE_BUY, type PrepareNewOrder } from './types';
import { useOrder } from './useOrder';

export interface BuyOptions extends WagmiCallbacks {}

export function useBuy({ onError, onSuccess }: BuyOptions = {}) {
    const { newOrder, getChain, getCollectibleIdentifier } = useOrder({
        onError: handleError,
        onSuccess: handleSuccess,
    });
    const { addConfirmedToken, addToken, removeToken, token } = useBuyStore();

    function defaultErrorHandler() {
        removeToken();
    }

    function handleError(error?: unknown, variables?: unknown, context?: unknown) {
        return onError ? onError(error, variables, context) : defaultErrorHandler();
    }

    function defaultSuccessHandler() {
        const confirmedToken = token;
        if (confirmedToken) {
            removeToken();
            addConfirmedToken(confirmedToken);
        }
    }

    function handleSuccess(data?: unknown, variables?: unknown, context?: unknown) {
        return onSuccess ? onSuccess(data, variables, context) : defaultSuccessHandler();
    }

    async function buyNow(token: MarketplaceBuyAsset) {
        addToken(token);

        const chain = token.collectibleId?.substring(0, token.collectibleId?.indexOf('.'));

        await newOrder({
            settings: PREPARE_BUY,
            order: {
                allMarkets: false,
                chain: chain?.toUpperCase() as PrepareNewOrder['chain'],
                item: {
                    // collectibleIdentifier: getCollectibleIdentifier({
                    //     chain: CollectionChainType.Polygon,
                    //     contractAddress: token.collection.contractAddress,
                    //     tokenId: token.tokenId,
                    // }),
                    collectibleIdentifier: token.collectibleId || '',
                    quantity: 1,
                },
            },
            onComplete: () => {
                removeToken();
            },
            onError: handleError,
        });
    }

    return {
        buyNow,
        handleError,
    };
}
